const YesNoRadioComponent = {
    templateUrl: '/formViewer/component/yesNoRadio/yesNoRadio.tpl.html',
    controller: 'yesNoRadioController',
    bindings: {
        fieldStructure: '<',
        timeLastModified: '<',
        hideLabel: '<'
    }
};

angular.module('umFormViewer')
    .component('uiYesNoRadio', YesNoRadioComponent);
